<div class="header_content">
  <div class="logo">
    <img src="assets/images/smart_tos_globicon_logo.png" alt="Logo" height="24" />
  </div>

  <div class="search_bar">
    <app-multi-select
      [options]="headerOptions"
      displayKey="label"
      valueKey="value"
      [isMultiSelect]="false"
      (selectionChange)="handleOptionsChange($event)"
      [selectDefault]="true"
    ></app-multi-select>
    <div class="search-separator"></div>
    <app-dynamic-form
      [formConfig]="selectedSearchBarConfig?.dynamicFormConfig"
      [formGroup]="searchBarForm"
      (onValueChange)="handleSubmit()"
    ></app-dynamic-form>
    <button class="search-btn" (click)="handleSubmit()">
      <app-svg-icon path="assets/icons/search_icon.svg"></app-svg-icon>
    </button>
  </div>


  <div class="actions_btns">
    <div class="notification_btn"></div>
    <div class="user_badge" nz-dropdown [nzDropdownMenu]="menu" nzTrigger="click">
      <div class="avatar_icon">
        <app-svg-icon path="assets/icons/admin_menu_icon.svg"></app-svg-icon>
      </div>
      <div class="user_name">{{ userProfile?.name }}</div>
      <app-svg-icon path="assets/icons/chevron_down.svg" style="height: 14px;width: 14px"></app-svg-icon>
    </div>
  </div>
</div>


<nz-dropdown-menu #menu="nzDropdownMenu">
  <ul nz-menu class="dropdown_menu">
<!--    <li nz-menu-item>-->
<!--      <app-svg-icon path="assets/icons/settings_menu_icon.svg"></app-svg-icon>-->
<!--      Settings-->
<!--    </li>-->
    <li nz-menu-item routerLink="/user-profile" [nzSelected]="isSelected('/user-profile')">
      <app-svg-icon path="assets/icons/admin_menu_icon.svg" [ngStyle]="{
        backgroundColor: isSelected('/user-profile') ? '#1062B9' : 'var(--gray-900)',
      }"></app-svg-icon>
      View Profile
    </li>
    <li nz-menu-item (click)="onLogout()" class="logout_icon">
      <app-svg-icon path="assets/icons/logout.svg"></app-svg-icon>
      Logout
    </li>
  </ul>
</nz-dropdown-menu>
